@if (showLdr) {
<ds-loading></ds-loading>
}

<div class="row hdrBar">
  <div class="col-lg-8 col-md-8 mg-a">
    @if (clntDtls && clntDtls.length > 0) {
    <h1>Desludging Dashboard</h1>
    }
  </div>
  <div class="col-lg-4 col-md-4 mg-a" style="text-align: right">
    <span>Select Date:</span>
    <nz-date-picker
      [nzDisabledDate]="disabledDate"
      [nzFormat]="dateFormat"
      [(ngModel)]="slctdDt"
      (ngModelChange)="onChange($event)"
    ></nz-date-picker>
  </div>
</div>

<div class="main">
  <!-- <h1>Desludging Dashboard</h1> -->
  <div class="row">
    <ul class="cards">
      @for (d of tdyCoveredTrips; track d) {
      <li class="cards_item">
        <div
          class="card_g"
          style="background: linear-gradient(135deg, #ab89f7 0%, #7367f0 100%)"
        >
          <div class="card_content">
            <div class="row">
              <h1 class="crdHdr">Total Vehicles</h1>
            </div>
            <div class="row crdHdr_sb">
              <div class="col-lg-6 col-md-6">
                <h1>
                  <i nz-icon nzType="car" nzTheme="outline"></i>
                </h1>
              </div>
              <div class="col-lg-6 col-md-6">
                <h1 class="card_sub_title">{{ d.ttl }}</h1>
              </div>
            </div>
            <div class="row crdHdr_sb_sm">
              <div class="col-lg-6 col-md-6">
                <h1>Opearted</h1>
              </div>
              <div class="col-lg-6 col-md-6">
                <h1 class="card_sub_title">
                  {{ d.operated === null ? "NA" : d.operated }}
                </h1>
              </div>
            </div>
            <div class="row crdHdr_sb_sm">
              <div class="col-lg-6 col-md-6">
                <h1>Not-Operated</h1>
              </div>
              <div class="col-lg-6 col-md-6">
                <h1 class="card_sub_title">{{ d.notoperated }}</h1>
              </div>
            </div>
          </div>
        </div>
      </li>
      } @for (d of ttlTrpsCnt; track d) {
      <li class="cards_item">
        <div
          class="card_g"
          style="background: linear-gradient(135deg, #40d99d 0%, #3bb2b8 100%)"
        >
          <div class="card_content">
            <div class="row">
              <h1 class="crdHdr">Trips Travelled</h1>
            </div>
            <div class="row crdHdr_sb">
              <div class="col-lg-6 col-md-6">
                <h1>
                  <i nz-icon nzType="car" nzTheme="outline"></i>
                </h1>
              </div>
              <div class="col-lg-6 col-md-6">
                <!-- <h1 class="card_sub_title">{{d.tdy_trps + d.ysd_trps}}</h1> -->
              </div>
            </div>
            <div class="row crdHdr_sb_sm">
              <div class="col-lg-6 col-md-6">
                <h1>Today</h1>
              </div>
              <div class="col-lg-6 col-md-6">
                <h1 class="card_sub_title">{{ d.tdy_trps }}</h1>
              </div>
            </div>
            <div class="row crdHdr_sb_sm">
              <div class="col-lg-6 col-md-6">
                <h1>Yesterday</h1>
              </div>
              <div class="col-lg-6 col-md-6">
                <h1 class="card_sub_title">{{ d.ysd_trps }}</h1>
              </div>
            </div>
          </div>
        </div>
      </li>
      } @for (d of ttlDstncCnt; track d) {
      <li class="cards_item">
        <div
          class="card_g"
          style="background: linear-gradient(135deg, #f6ab84 0%, #f38381 100%)"
        >
          <div class="card_content">
            <div class="row">
              <h1 class="crdHdr">Distance Travelled (km)</h1>
            </div>
            <div class="row crdHdr_sb">
              <div class="col-lg-6 col-md-6">
                <h1>
                  <i nz-icon nzType="node-index" nzTheme="outline"></i>
                </h1>
              </div>
              <div class="col-lg-6 col-md-6">
                <!-- <h1 class="card_sub_title">{{d.tdy_dstnc + d.ysdy_dstnc}}</h1> -->
              </div>
            </div>
            <div class="row crdHdr_sb_sm">
              <div class="col-lg-6 col-md-6">
                <h1>Today (km)</h1>
              </div>
              <div class="col-lg-6 col-md-6">
                <h1 class="card_sub_title">{{ d.tdy_dstnc }}</h1>
              </div>
            </div>
            <div class="row crdHdr_sb_sm">
              <div class="col-lg-6 col-md-6">
                <h1>Yesterday (km)</h1>
              </div>
              <div class="col-lg-6 col-md-6">
                <h1 class="card_sub_title">{{ d.ysdy_dstnc }}</h1>
              </div>
            </div>
          </div>
        </div>
      </li>
      }
    </ul>
  </div>

  <div class="row bg-wp">
    <h1>ULB Wise Desludging Trips</h1>
    <div class="ds-card grid tbl">
      <app-data-grid
        [totalItems]="gridTotals0"
        [groupItems]="gridGroups0"
        class="p-8"
        style="width: 100%"
        [dataSource]="ulbwseDsldgngTripsDta"
        [legacyColumns]="ulbwseDsldgngTripscolumnDefs"
        [searchPanel]="true"
        [filterRow]="false"
        [filterPanel]="false"
        [groupPanel]="true"
        [columnChooser]="true"
        [allowExport]="true"
        exportFileName="ULB Trips Data"
        [pageSize]="10"
        [allowedPageSizes]="[10, 25, 50, 100]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
        [cellPrepared]="bound_onCellPrepared"
      >
        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="true"
          type="buttons"
          [width]="100"
          caption="View"
          cellTemplate="editTemplate"
        ></app-grid-column>
        <ng-template appGridCell="editTemplate" let-data="cell"
          ><div>
            <div class="tblEdtBtn" (click)="gotoUlb(data)">Quick View</div>
          </div></ng-template
        >
      </app-data-grid>
    </div>
  </div>

  <div class="row bg-w">
    <h1 style="padding-left: 20px">Heat Map (Last 7Days Trips Travelled)</h1>
    <div id="chartdiv"></div>
  </div>
  <div class="row bg-w">
    <div class="col-lg-6 col-md-6">
      <h1>Distance Travelled Last 7Days</h1>
      <div id="distanceTavelledChart"></div>
    </div>
    <div class="col-lg-6 col-md-6">
      <h1>Trips Travelled Last 7Days</h1>
      <div id="tripsTavelledChart"></div>
    </div>
  </div>
</div>
